export const CHOOSE_BAR = 'CHOOSE_BAR';

export function chooseBar(bar, branch) {
    return {
        type: CHOOSE_BAR,
        payload: {bar, branch}
    };
}



// WEBPACK FOOTER //
// ./src/common/bars/actions.js